var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptySet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 1.5c-.625-.625-1.563-.625-2.125 0l-4.688 4.625C23.375 4.187 20.313 3 17 3 9.25 3 3 9.313 3 17c0 3.375 1.125 6.375 3.063 8.813l-4.625 4.625c-.625.625-.625 1.562 0 2.125.25.312.625.437 1.062.437.375 0 .75-.125 1-.438l4.688-4.624C10.562 29.875 13.625 31 17 31c7.688 0 14-6.25 14-14 0-3.313-1.188-6.375-3.125-8.75L32.5 3.625c.625-.625.625-1.563 0-2.125zM6 17c0-6.063 4.875-11 11-11 2.438 0 4.75.875 6.625 2.25L8.187 23.688A11.271 11.271 0 0 1 6 17zm22 0c0 6.125-4.938 11-11 11-2.5 0-4.813-.813-6.688-2.188L25.75 10.376C27.125 12.25 28 14.563 28 17z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySet);
export default __webpack_public_path__ + "static/media/empty-set.6ec995ac9d8f78f5940ed2eff6d24d7b.svg";
export { ForwardRef as ReactComponent };